// extracted by mini-css-extract-plugin
export default {"row":"KeyValue_row__Ht3dv","key":"KeyValue_key__rpH4y","value":"KeyValue_value__zJfJt"};